module.exports = __webpack_public_path__ + "bg-photo-tablet-landscape.webp?7e3133775fe1d680cd3178188946ed09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-photo-tablet-landscape.webp
// module id = 201
// module chunks = 0